import { classifyDevice } from '../constants';
import axiosInstance from './axios-instance';

export const fetchAd = async (id) => {
  const result = await axiosInstance.post(`/api/v1/backend/ad/deliver`, {
    twygsId: id,
    device: classifyDevice(),
    platform: 'MAIN_WEBSITE'
  });

  return result.data;
};

export const googleAdInteract = async (interactId) => {
  const result = await axiosInstance.post(`/api/v1/backend/ad/google/interact`, {
    interactionObjectId: interactId,
    interactionType: 'view',
    interactionPlatform: 'newsletter'
  });

  return result.data;
};
